import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<Props> = ({
  show,
  message,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl">
        <div className="p-6">
          <p className="text-sm text-gray-700">{message}</p>
        </div>
        <div className="flex justify-end gap-3 border-t border-gray-100 px-6 py-4">
          <button
            className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100"
            onClick={onCancel}
          >
            {t("confirmModal.cancel")}
          </button>
          <button
            className="rounded-lg bg-danger px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-600"
            onClick={onConfirm}
          >
            {t("confirmModal.delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
